import {sanatizeCsv} from "@/utilities/helpers/CsvSanitizer";
import {User} from "@/models/entities/users/User";
import {Plant} from "@/models/entities/plants/Plant";

export class UserCsvExport{
    FirstName: string;
    LastName: string;
    Email: string;
    KID: string;
    DialCode: string;
    PhoneNumber: string;
    CompanyId?:string;
    Roles: Array<string>;

    constructor (fullObj:User){
        this.FirstName = sanatizeCsv(fullObj.firstName);
        this.LastName = sanatizeCsv(fullObj.lastName);
        this.Email = sanatizeCsv(fullObj.email ?? "");
        this.KID = sanatizeCsv(fullObj.ssoIdentifier ?? "");
        this.DialCode = sanatizeCsv(`${fullObj.dialCode}`, true);
        this.PhoneNumber = sanatizeCsv(`${fullObj.phoneNumber}`);
        this.CompanyId = sanatizeCsv(fullObj.companyId);
        this.Roles = fullObj.roles.map((r:string) => sanatizeCsv(r));
    }
}

export class PlantCsvExport{
    Id:string;
    Name:string;
    Longitude:string;
    Latitude:string;
    Email:string;
    HouseNumber:string;
    ApplicationRadius:string;
    Street:string;
    Postalcode:string;
    City:string;
    PhoneNumber:string;

    constructor (fullObj:Plant){
        this.Id = sanatizeCsv(fullObj.id);
        this.Name = sanatizeCsv(fullObj.name);
        this.Longitude = fullObj.longitude?.toString() ?? "";
        this.Latitude = fullObj.latitude?.toString() ?? "";
        this.Email = sanatizeCsv(fullObj.email);
        this.HouseNumber = sanatizeCsv(fullObj.houseNumber);
        this.ApplicationRadius = fullObj.applicationRadius?.toString() ?? "";
        this.Street = sanatizeCsv(fullObj.street);
        this.Postalcode = fullObj.postalcode?.toString() ?? "";
        this.City = sanatizeCsv(fullObj.city);
        this.PhoneNumber = sanatizeCsv(fullObj.phoneNumber, true);
    }
}